import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as ArrowLeftIcon } from './arrowLeft.svg';

export const ArrowLeft = IconHOC(ArrowLeftIcon);
